export default __webpack_public_path__ + "static/media/training.fdc89f11.png";